import DCCol from './col';
export default DCCol;
